// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";

function ModificationLegends(Props) {
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-modification-legends"
            }, React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", {
                      className: "legend active"
                    }), "ACTIVE"), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", {
                      className: "legend scheduled"
                    }), "SCHEDULED"), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", {
                      className: "legend pending"
                    }), "PENDING"));
}

var make = ModificationLegends;

export {
  make ,
  
}
/* react Not a pure module */
